// extracted by mini-css-extract-plugin
module.exports = {"footerBar":"footer-module--footerBar--1-CyB","footerContent":"footer-module--footerContent--2k30_","footerColumn":"footer-module--footerColumn--2uqiQ"};